import { createFileRoute } from '@tanstack/react-router';
import AttendanceMonthlyReportTable from '@/modules/attendance/attendance-monthly-report/AttendanceMonthlyReportTable';

export const Route = createFileRoute('/(dashboard)/_dashboard/attendance/monthly-report')({
  component: AttendanceMonthlyReportTable,
});
